<template>
    <div id="InventoryTicketList">
        <div :class="`loader${loaderClass}`" v-show="loading">
        </div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <div class="page-title"> InventoryTicket List</div>
                    <div class="web-action-btn btn-groups text-right">
                        <router-link class="btn btn-primary" v-bind:to="{name: 'PhysicalCountList'}" > <i class="fp-back"> </i> Back</router-link>
                        <div class="dropdown pull-right filter-dropdown">
                          <button v-on:click="generateSheet('count_sheet')" class="btn btn-secondary pull-left" type="button" aria-haspopup="true" aria-expanded="false" style="border-top-right-radius: 0;border-bottom-right-radius: 0;">
                            <i class="fp-export"></i> Count Sheet
                          </button>
                          <button class="btn btn-secondary dropdown-toggle pull-left" id="dropdownMenuButton" data-toggle="dropdown" style="border-top-left-radius: 0;border-bottom-left-radius: 0;"><span class="caret"></span></button>
                          <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                              <a class="dropdown-item" href="javascript:void(0)" v-on:click="generateSheet('variance_sheet')"><i class="fp-export"></i> Variance Sheet</a>
                          </div>
                        </div>
                        <button type="button" id="UpdateQuantity" class="btn btn-primary mr-1" v-on:click.prevent="createQuantity" >
                            <i class="fp-add"> </i>  Update Quantity
                        </button>
                    </div>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content physical-count-list">
                        <section class="internal-container border-top-table-fl">
                            <div class="form-row asset-top-section">
                                <div class="col-sm-3">
                                    <label class="control-label" for="Vehicle">Count Number:</label>
                                    <span class="label">{{countNumber}}</span>
                                </div>
                                <div class="col-sm-3">
                                    <label class="control-label" for="Vehicle">Location:</label>
                                    <span class="label">{{location}}</span>
                                </div>
                                <div class="col-sm-3">
                                    <label class="control-label" for="Vehicle">Warehouse:</label>
                                    <span class="label">{{warehouse}}</span>
                                </div>
                                <div class="col-sm-3">
                                    <label class="control-label" for="Vehicle">Date:</label>
                                    <span class="label">{{count_date}}</span>
                                </div>
                            </div>
                        </section>
                        <section class="data-table bg-white">
                            <data-table-filter-config :moduleName="'inventoryTicketList'" @cancelSelection="cancelAll"></data-table-filter-config>
                                <custom-pagination
                                    :page-changed="onPageChange"
                                    :per-page-changed="onPerPageChange" :moduleName="'inventoryTicketList'" :position="'top'">
                                </custom-pagination>
                                <vue-good-table
                                    class="inventory_ticket"
                                    ref="listInventoryTicketTable"
                                    mode="remote"
                                    title="Inventory Ticket"
                                    @on-page-change="onPageChange"
                                    @on-selected-rows-change="selectionChanged"
                                    @on-column-filter="onColumnFilter"
                                    @on-per-page-change="onPerPageChange"
                                    @on-sort-change="onSortChange"
                                    :totalRows="totalRecords"
                                    :columns="userColumns"
                                    :rows="rows"
                                    :pagination-options="{
                                        enabled: false,
                                        position: 'both',
                                        perPage: perPage,
                                        perPageDropdown:dropDownPerPage,
                                        dropdownAllowAll: false,
                                    }"
                                    :select-options="{
                                    enabled: false,
                                    selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                                    selectionInfoClass: 'custom-class',
                                    selectionText: 'rows selected',
                                    clearSelectionText: 'clear',
                                    }"
                                    :search-options="{
                                    enabled: false,
                                    }">

                                    <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">

                                        <div :key="key">
                                            <div v-if="props.column.field == 'actual_count'" class='text-center form-group mb-0'>
                                                <template v-if="props.row.status.toLowerCase() != 'closed' && props.row.status.toLowerCase() != 'confirmed'">
                                                    <input type="text"  style="width:auto;" class="form-control text-right pull-right phy-cnt-inp" :id="'quantity'+props.row.id" v-model="props.row.actual_count" @keypress="isAmountCheck($event)" />
                                                </template>
                                                <template v-else>
                                                    {{props.formattedRow[props.column.field]}}
                                                </template>
                                            </div>
                                            <div v-else-if="props.column.field == 'inv_qty'" class='text-center form-group mb-0'
                                                :id="'inv_qty_'+props.row.id"> {{ props.row.inv_qty}}
                                            </div>
                                            <div v-else-if="props.column.field == 'actual_count'" class='text-center form-group mb-0'>
                                                    <template v-if="props.row.status.toLowerCase() != 'closed' && props.row.status.toLowerCase() != 'confirmed'">
                                                        <input type="text" style="width:auto;"
                                                            class="form-control text-right pull-right"
                                                            :id="'quantity'+props.row.id" v-model="props.row.actual_count"
                                                            @input="isAmountCheck($event) && calculateDifference($event, props.row.id, props.row.inv_qty)"/>
                                                    </template>
                                                    <template v-else>
                                                    {{ props.formattedRow[props.column.field] }}
                                                    </template>
                                            </div>
                                            <div v-else-if="props.column.field == 'difference'"
                                                :id="'difference'+props.row.id"
                                                class='text-center form-group mb-0'>

                                              {{calculateDifferenceOnStart(props.row.actual_count, props.row.inv_qty)}}
                                            </div>
                                            <!-- <div v-if="props.column.field == 'tick'">
                                                    <router-link title="View Item Ticket" class="color-blue" v-bind:to="{name: 'InventoryTicket',params:{id:props.row.id}}">{{props.row.count_number}}</router-link>
                                            </div> -->
                                            <div v-else>
                                                {{props.formattedRow[props.column.field]}}
                                            </div>
                                        </div>

                                    </template>

                                    <div slot="selected-row-actions">

                                    </div>
                                </vue-good-table>
                                <custom-pagination
                                    :page-changed="onPageChange"
                                    :per-page-changed="onPerPageChange">
                                </custom-pagination>
                        </section>
                        <div class="form-group">
                            <div class="alert alert-warning hide col-sm-6" id="alertError">
                                <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                <strong id="errorMsg" class="field-error"></strong>
                            </div>
                        </div>
                        <div class="btn-groups">
                            <button type="button" id="UpdateQuantity" class="btn btn-primary" v-on:click.prevent="createQuantity" >
                                <i class="fp-add"> </i>  Update Quantity
                            </button>

                            <!-- <router-link class="btn btn-primary pull-right" v-bind:to="{name: 'PhysicalCountList'}" > <i class="fp-back"> </i> Cancel</router-link> -->
                        </div>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>

import Vue from "vue";
import EventBus from "././event-bus";
import {commonMixins} from '../mixins/commonMixins';
import {dataTableMixins} from '../mixins/dataTableMixins';

    export default {
        name: "InventoryTicketList",
        metaInfo() {
            return {title: "Physical Count List | " +process.env.COPYRIGHT_NAME}
        },
        mixins:[commonMixins,dataTableMixins],
        data: () => ({
            active: 8,
            firstLoad: 0,
            permissions: [],
            cantAccessPage: "",
            userColumns:[],
            countNumber:'',
            location:'',
            count_date:'',
            columns: [
                // {
                //     label: 'Actions',
                //     field: 'action',
                //     hidden:false,
                //     sortable: false,
                // },
                {
                    label: 'Ticket Number',
                    field: 'ticket_number',
                    filterable: true,
                    fpFieldType:"text",
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Ticket Number", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Row',
                    field: 'row',
                    filterable: true,
                    fpFieldType:"text",
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Row", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Shelf',
                    field: 'shelf',
                    filterable: true,
                    fpFieldType:"text",
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Shelf", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Bin',
                    field: 'bin',
                    filterable: true,
                    fpFieldType:"text",
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Bin", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Mfg',
                    field: 'manufacturer',
                    filterable: true,
                    hidden:false,
                    fpFieldType:"text",
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Mfg", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Item Number',
                    field: 'item',
                    filterable: true,
                    hidden:false,
                    fpFieldType:"text",
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Item", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Description',
                    field: 'description',
                    filterable: true,
                    hidden:false,
                    fpFieldType:"text",
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Description", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },

              {
                label: 'Amount',
                field: 'amount',
                filterable: true,
                hidden:false,
                fpFieldType:"integer",
                type:'number',
                filterOptions: {
                  enabled: false, // enable filter for this column
                  placeholder: "amount", // placeholder for filter input
                  filterValue: '', // initial populated value for this filter
                  trigger: "enter" //only trigger on enter not on keyup
                }
              },


              {
                    label: 'Frozen Book',
                    field: 'inv_qty',
                    filterable: true,
                    hidden:false,
                    fpFieldType:"integer",
                    type:'number',
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "inv_qty", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Actual Count',
                    field: 'actual_count',
                    filterable: true,
                    hidden:false,
                    type:'number',
                    fpFieldType:"integer",
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Actual Count", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
              {
                label: 'Difference',
                field: 'difference',
                filterable: false,
                sortable: false,
                hidden:false,
              },
                // {
                //     label: 'UOM',
                //     field: 'uom',
                //     filterable: true,
                //     hidden:false,
                //     fpFieldType:"text",
                //     filterOptions: {
                //         enabled: false, // enable filter for this column
                //         placeholder: "UOM", // placeholder for filter input
                //         filterValue: '', // initial populated value for this filter
                //         trigger: "enter" //only trigger on enter not on keyup
                //     }
                // },
                // {
                //     label: 'Status',
                //     field: 'status',
                //     filterable: true,
                //     hidden:false,
                //     fpFieldType:"option",
                //     filterOptions: {
                //         enabled: false, // enable filter for this column
                //         placeholder: "Actual Count", // placeholder for filter input
                //         filterValue: '', // initial populated value for this filter
                //         trigger: "enter" //only trigger on enter not on keyup
                //     }
                // },
            ],
            rows: [],
            totalRecords: 0,
            term_value: false,
            loading:false,
            fromUrl:"",
            warehouse:'',
            action_type: "list_data"
        }),
        watch:{

            //check permission change
            permissions: function (permissions) {

                var self = this;
                if (permissions.length > 0) {
                    for (var i = 0; i < permissions.length; i++) {
                        if (permissions[i].name == 'add_component') {
                            self.cantAccessPage = true;
                        }
                    }
                }

            }

        },
        created: function() {

        },
        mounted: function() {
            var self = this;

            //self.loadList();
            self.getPermissions();
            // self.fromUrl = btoa(window.location.pathname);

            var path = window.location.pathname;
            var segments = path.split("/");

            self.countNumber = segments[3];

            let vm = this;
            $(document).keyup(function (e) {

                if ( $(e.target).hasClass( "phy-cnt-inp" )) {
                    if ( e.keyCode == 40 ) {
                        $(e.target).closest('tr').next('tr').find('.phy-cnt-inp').focus();
                    }
                    if ( e.keyCode == 38 ) {
                        $(e.target).closest('tr').prev('tr').find('.phy-cnt-inp').focus();
                    }
                }
            });
        },
        methods: {

            moveFocus(evt) {

                if ( evt.keyCode == 40 ) {
                    //evt.target.nextElementSibling.focus()
                    $( evt.target ).next('.phy-cnt-inp').focus();
                }
                console.log("key code ..",evt.keyCode);
            },
            cancelAll: function (cancelAll) {
              this.$refs.listProgramTable.unselectAllInternal();
            },
            selectionChanged(param) {
                var self = this;
                if(param.selectedRows.length == 100) {
                  EventBus.$emit('clear-selection', false);
                } else {
                  EventBus.$emit('clear-all-flags', false);
                }
                // console.log(self.computed.selectedRows);
                // var rowData = self.$refs['my-table'].selectedRows;
                // console.log(rowData);
            },

            loadList() {
                var self = this;
                self.loading = true;
                var fields = {
                    page: self.serverParams.page,
                    perPage: self.serverParams.perPage,
                    filters: self.serverParams.columnFilters,
                    sort: self.serverParams.sort,
                    count_number: self.countNumber,
                    action_type: self.action_type
                };
                self.firstLoad = 1;
                $.ajax({
                    url: process.env.ROOT_API + "/inventory-ticket/list",
                    type: "POST",
                    data: fields,
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        if (data.status == "success") {


                            if(data.action_type == "count_sheet" || data.action_type == "variance_sheet"){
                              var link = document.createElement('a');
                              document.body.appendChild(link);
                              link.href = data.path;
                              link.download = '';
                              link.target = "_blank";
                              link.click();
                              self.action_type = 'list_data'
                            }else {
                              if (data.content.row[0]){
                                self.location = data.content.row[0].location;
                                self.count_date = data.content.row[0].count_date;
                                self.warehouse = data.content.row[0].warehouse;
                                self.rows = data.content.row;
                                self.totalRecords = data.content.totalRecords;
                              }
                            }
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,false,'program-list')
                    }
                });
            },

            createQuantity:function(){
                var self = this;
                var ticketArr = [];
                for(var i = 0; i < self.rows.length; i++){
                    if ( $("#quantity"+self.rows[i].id).val() > 0){
                        var arr = {};
                        arr['id'] = self.rows[i].id;
                        arr['quantity'] = $("#quantity"+self.rows[i].id).val();
                        ticketArr.push(arr);
                    }
                }

                if (!ticketArr.length){
                    self.$swal('','Please add quantity in any item','info');
                    return;
                }

                $.ajax({
                    url: process.env.ROOT_API + "/inventory-quantity/update",
                    type: "POST",
                    data: {
                        arr:JSON.stringify(ticketArr)
                    },
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        // console.log(data);
                        if (data.status == "success") {
                          self.$swal('','Quantity Updated','success');
                          self.loadList();
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,false,'program-list')
                    }
                });
            },

          calculateDifference(event, rowId, quantity) {
            var actual_count = event.target.value;
            var diff = quantity - actual_count
            var fixedDiff = diff.toFixed(2)
            var $rows = $('#difference'+rowId);
            $rows.empty();
            $rows.html(fixedDiff);
          },

           calculateDifferenceOnStart( quantity, actual_count) {
              var diff = quantity - actual_count;
             return diff.toFixed(2);
            },

          generateSheet: function (flag) {
            var self = this;
            self.action_type = flag
            self.loadList()
          },
        }
    };
</script>



// WEBPACK FOOTER //
// src/components/InventoryTicketList.vue